import { IssueKind } from "../types/Api";
export var isSpecialKind = function (kind) {
    return kind === IssueKind.SPECIAL_SUB || kind === IssueKind.SPECIAL_STANDALONE;
};
export var isIrregularKind = function (kind) {
    return kind === IssueKind.IRREGULAR;
};
